
<p-toast></p-toast>
<p-fileUpload name="demo[]" (onUpload)="onUpload($event)"
[multiple]="multiple" accept="image/*" [maxFileSize]="maxFileSize">
  <ng-template pTemplate="content">
    <div *ngIf="uploadedFiles.length === 0">
      <h3 class="taC">No tienes imágenes</h3>
      <h5 class="taC">Haz clic en el botón de abajo para cargar la imagen.</h5>
      <button pButton pRipple type="button" label="Subir nuevo archivo" class="p-button-raised p-button-success uploadBtn" *ngIf="uploadedFiles.length === 0"></button>

    </div>
    <ul *ngIf="uploadedFiles.length">
      <li *ngFor="let file of uploadedFiles">{{file.name}} - {{file.size}} bytes</li>
    </ul>
  </ng-template>
</p-fileUpload>

